export default {
    fund: [{
            "title": "关于沪港通开通的意义，以下表述错误的是（　　）。",
            "question": "A. 完善了国内资本市场\nB. 推动人民币跨境资本流动\nC. 维护人民币和港币之间的汇率稳定\nD. 构建良好的人民币回流机制",
            "answer": "C",
            "explain": "沪港通的意义表现为：(1)刺激人民币资产需求，加大人民币交投量；(2)推动人民币跨境资本流动；(3)构建良好的人民币回流机制；(4)完善国内资本市场。综上所述，A、B、D选项表述正确，C选项表述错误。"
        },
        {
            "title": "以下不属于银行间债券市场全额结算优点的是（　　）。",
            "question": "A. 有利于保持交易的稳定和结算的及时性\nB. 降低市场参与者结算成本和相关风险\nC. 每个市场参与者都可监控自己参与的每一笔交易结算进展情况，从而评估自身对不同对手方的风险暴露\nD. 降低结算本金风险",
            "answer": "B",
            "explain": "全额结算也称逐笔结算，是指结算系统对每笔债券交易都单独进行结算，一个买方对应一个卖方，当一方遇券或款不足时，系统不进行部分结算。全额结算过程中，结算机构对所有参与结算的对手方，不对结算完成进行担保。"
        },
        {
            "title": "关于机构投资者的总体特征，以下表述正确的是（　　）。",
            "question": "A. 常常需要借助基金销售机构进行投资\nB. 投资管理相对专业\nC. 风险承受能力较弱\nD. 资金量较小",
            "answer": "B",
            "explain": "机构投资者的特征：(1)资金实力雄厚，投资规模相对较大；(2)具有比个人投资者更高的风险承受能力；(3)投资管理专业；(4)投资行为规范。"
        },
        {
            "title": "在其他因素不变的情况下，当企业用现金购买存货时，流动比率和速动比率分别（　　）。",
            "question": "A. 降低不变\nB. 不变降低\nC. 不变不变\nD. 降低升高",
            "answer": "B",
            "explain": "流动比率=流动资产÷流动负债，速动比率=(流动资产-存货)÷流动负债；使用现金购买存货，是流动资产的内部转换，不影响流动比率(流动资产不变，存货增加，流动资产减去存货数值降低，则速动比率降低。"
        },
        {
            "title": "关于远期利率的表述错误的是（　　）。",
            "question": "A. 远期利率可以表示投资者在未来特定日期购买的零息债券的到期收益率\nB. 远期利率是未来某一时点到另一时点的利率水平\nC. 远期利率的计息日起始点是当前的时点\nD. 远期利率可以通过无套利原则利用即期利率推算得到",
            "answer": "C",
            "explain": "远期利率是指未来一个时点到另一个时点的利率水平，也可以表示投资者在未来特定日期购买的零息债券的到期收益率。远期利率与即期利率的区别在于计息日起点不同，其中远期利率的起点在未来某一时刻。远期利率可以通过无套利原则利用即期利率推算得到。"
        },
        {
            "title": "当前，我国的基金运作费包括（　　）。",
            "questions": "I. 基金验资费<br>II. 上市年费<br>III. 持有人大会费<br>IV. 持仓股票调研费",
            "question": "A. I、IV\nB. I、III\nC. II、III\nD. I、II",
            "answer": "C",
            "explain": "基金运作费指为保证基金正常运作而发生的应由基金承担的费用，包括审计费、律师费、上市年费、分红手续费、持有人大会费、开户费、银行汇划手续费等。"
        }, {
            "title": "关于即期利率，以下表述错误的是（　　）。",
            "question": "A. 即期利率是已设定到期日的零息债券的到期收益率\nB. 一般而言，即期利率随期限变化\nC. 利息和本金都是在到期日支付\nD. 即期利率的计息日起点在未来的某一时刻",
            "answer": "D",
            "explain": "即期利率是金融市场中的基本利率，能已设定到期日的零息需债券的到期收益率，它表示的是从现在(t=0)到时间比的年化收益率。利息和本金都是在到期日t支付的。考虑到利率随期限长短的变化，对于不同期限的现金流，人们通常采用不同的利率水平进行贴现，这个随期限而变化的利率就是即期利率。即期利率与远期利率的区别在于两者的计息日起点不同，即期利率的起点在当前时刻，而远期利率的起点在未来某一时刻。"
        },
        {
            "title": "银行间公开市场一级交易商是指中国人民银行根据规定选择符合条件的债券二级市场参与者作为（　　）的对手方与之进行债券交易。",
            "question": "A. 财政部\nB. 中央结算公司\nC. 上海清算所\nD. 中国人民银行",
            "answer": "D",
            "explain": "公开市场一级交易商制度是指中国人民银行根据规定通讯符合条件的债券二级市场参与者作为中国人民银行的对手方，与之进行债券交易，从而配合中国人民银行货币政策目标的实现。"
        },
        {
            "title": "关于跟踪误差，以下表述正确的是（　　）。",
            "question": "A. 主动管理基金的跟踪误差通常比较小\nB. 跟踪误差是一个绝对风险指标\nC. 跟踪误差计量的前提是清晰的业绩比较基准\nD. 跟踪误差无法衡量投资组合的相对风险是否符合预定的目标",
            "answer": "C",
            "explain": "跟踪误差是度量一个股费明合相对于某基准烟合偏离程度的重要指标。该指标被广泛用于被动投资及主动投资管理者的业绩考核，并且这里指的业绩既可以是事前的，也可以是事后的。跟踪误差是证券组合相对基准的跟踪偏高度的标准差。"
        },
        {
            "title": "股票基金管理人会密切关注行业和个股的基本面变化，构建股票投资组合。这种操作主要是为了降低哪种风险（　　）。",
            "question": "A. 市场风险\nB. 利率风险\nC. 信用风险\nD. 流动性风险",
            "answer": "A",
            "explain": "本题考查市场风险的管理。密切关注行业的周期性、市场竞争、价格、政策环境和个股的基本面变化，构造股票投资组合，分散非系统性风险，这主要是为了降低市场风险。"
        },
        {
            "title": "有关银行间债券市场做市商制度，以下表述正确的是（　　）。",
            "question": "A. 做市商作为中国人民银行的对手方，与之进行债券交易\nB. 做市商在银行间债券市场以自有资金和债券与投资者进行交易\nC. 做市商向投资者进行单方报价\nD. 做市商应对市场上所有债券进行报价",
            "answer": "B",
            "explain": "做市商制度，是指在债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，双向报价并在该价位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。"
        },
        {
            "title": "关于资本市场线与风险资产有效前沿的切点投资组合，以下表述正确的是（　　）。",
            "questions": "I. 它就是市场投资组合<br>II. 它由投资者偏好决定<br>III. 它是有效前沿上不含无风险资产的投资组合<br>IV. 有效前沿上的任何投资组合都可看作是该市场组合与无风险资产的再组合",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II\nD. I、III、IV",
            "answer": "D",
            "explain": "资本市场线与风险资产有效前沿的切点投资组合就是市场投资组合；它是有效前沿上唯一一个不含无风险资产的投资组合。"
        }, {
            "title": "关于互换合约，以下表述正确的是（　　）。",
            "question": "A. 利率互换有意票互换、基础互换、利息互换三种形式\nB. 进行利率互换的原因是双方在各自国家中的金融市场上具有比较优势\nC. 根据利息支付方式不同，货币互换有固定对固定、固定对浮动、浮动对浮动三种形式\nD. 进行货币互换的原因是双方在固定利率和浮动利率市场上分别具有比较优势",
            "answer": "C",
            "explain": "利率互换有息票互换和基础互换两种形式。进行货币互换的原因是双方在各自国家中的金融市场上具有比较优势；进行利率互换的原因是双方在固定利率和浮动利率市场上分别具有比较优势。根据利息支付方式不同，货币互换有固定对固定、固定对浮动、浮动对浮动三种形式。"
        },
        {
            "title": "关于系统性风险和非系统性风险，以下表述错误的是（　　）。",
            "question": "A. 经济增长和政治因素都属于引发非系统性风险的因素\nB. 系统性风险发生时所有资产均或多或少受到影响\nC. 系统性风险又称为市场风险\nD. 非系统性风险主要包括违约风险、经营风险、流动性风险",
            "answer": "A",
            "explain": "系统性风险，主要包括有政治因素，宏观经济因素、法律因素等引起的风险。"
        },
        {
            "title": "基金公司针对QDII基金实行的以下投资策略，不能有效规避跨境投资风险的是（　　）。",
            "question": "A. 通过不同国家地区的资产组合配置分散风险\nB. 通过外汇远期合约和货币交换等衍生工具来分散风险\nC. 通过多币种投资来分散风险\nD. 通过降低申购频率来控制资金的流动",
            "answer": "D",
            "explain": "跨境投资的风险管理方法之一是多币种投资和汇率避险操作相结合。QDII基金投资于全球多币种市场，不仅可有效降低投资单一市场所面临的汇率风险，还可分享比人民币走势更好的货币对人民币升值带来的好处。此外，QDII基金还可通过一些外汇远期合约和货币交换等衍生工具来进行汇率的避险操作。跨境投资的风险管理方法的另外一点是通过不同国家地区的资产组合配置分散风险。"
        },
        {
            "title": "私募股权投资基金A投资未上市公司M的股权，一段时间后，发生紧急资金需求，遂将所持有的M公司股权出售给私募股权投资基金B，之后私募股权投资基金B又收购了上市公司C，并通过反向收购将M公司注入C公司，实现M公司间接上市，私募股权投资基金A和私募股权投资基金B对M公司的股权投资，采取的退出机制分别为（　　）。",
            "question": "A. 破产清算和借壳上市\nB. 二次出售和借壳上市\nC. 二次出售和首次公开发行\nD. 破产清算和二次出售",
            "answer": "B",
            "explain": "二次出售是指私募股权投资基金将其持有项目在私募股权二级市场进行出售的行为。二次出售常用于缓解私募股权投资基金紧急的资金需求。私募股权投资基金A属于二次出售；买壳或借壳上市是指私募股权基金通过收购上市公司一定数量股份获得控制权后，再将自己所投资的企业通过反向收购注入该上市公司，实现公司间接上市。私募股权投资基金B属于借壳上市。"
        },
        {
            "title": "关于另类投资的局限，以下表述错误的是（　　）。",
            "question": "A. 信息透明度低\nB. 估值难度大\nC. 杠杆率较高\nD. 流动性较好",
            "answer": "D",
            "explain": "另类投资的局限性包括：(1)缺乏监管和信息透明度；(2)流动性较差，杠杆率偏高；(3)估值难度大，难以对资产价值进行准确评估。"
        },
        {
            "title": "关于结构化债券，以下表述错误的是（　　）。",
            "question": "A. 结构化债券主要包括住房抵押贷款支持证券和资产支持证券\nB. 资产支持证券中的标的资产种类可以是汽车消费贷款、学生贷款，也可以是信用卡应收款等多种形式\nC. 住房抵押贷款支持证券的资金流来自金融中介机构的定期放贷数\nD. 购买结构化债券的投资者通常定期获得资产池里的一部分现金，包括本金和利息",
            "answer": "C",
            "explain": "住房抵押贷款支持证券是以居民住房抵押贷款或商用住房抵押贷款组成的资金池为支持的，资金流来自住房抵押贷款人的定期还款，由金融中介机构打包建立资产池，C选项说法错误。"
        }, {
            "title": "以下（　　）不是期货合约的要素。",
            "question": "A. 期货品种\nB. 最小变动单位\nC. 行权价\nD. 交割等级",
            "answer": "C",
            "explain": "在签署一份新的期货合约时，期货交易所详细地规定了合约的确切条款，这主要包括期货品种、交易单位、最小变动单位、价格波动限制、交易时间、最后交易日和交割等级等一系列内容。行权价属于权证的基本要素。"
        },
        {
            "title": "认为市场利率将会在未来一段时期内持续上升的投资者最有可能会购买（　　）。",
            "question": "A. 零息债券\nB. 浮动利率债券\nC. 可转换债券\nD. 可赎回固定利率债券",
            "answer": "B",
            "explain": "浮动利率债券相比固定利率债券在利率下行环境中具有较高的利率风险，在利率上升环境中具有较低的利率风险。本题中，市场利率将会在未来一段时期内持续上升，则该投资者应当选择浮动利率债券。"
        },
        {
            "title": "某日某基金在A股市场以30元每股的价格一笔买入甲股票10000股，以25元每股的价格卖出乙股票4000股，假定当日没有其他交易。基金与证券经纪约定的佣金标准是万分之五，交易过程中的费用由基金自行承担，那么该基金当日应支付佣金金额为（　　）元。",
            "question": "A. 200\nB. 100\nC. 150\nD. 50",
            "answer": "A",
            "explain": "佣金是指交易成功后，投资者根据交易额，按照一定比例付给经纪人的费用，其是证券业收入的主要组成部分。本题中，基金在A股市场以30元每股的价格一笔买入甲股票10000股，以25元每股的价格卖出乙股票4000股，交易额为30×10000+25×4000=400000元，则本题中佣金=400000×0.05%=200元。"
        },
        {
            "title": "办理质押式回购业务时，确定回购利息支出的主要因素包括融资金额、融资利率和（　　）。",
            "question": "A. 融资的天数\nB. 融资的结算方式\nC. 质押率\nD. 质押券的信用等级",
            "answer": "A",
            "explain": "在质押式回购中，到期资金结算额=首期资金结算额×(1+回购利率×实际占款天数/365)，利息支出=到期资金结算额-首期资金结算额。由公式可以看出，利息支出的影响因素包括融资金额、融资利率和融资天数。"
        },
        {
            "title": "投资者选择艺术品投资作为多元化资产配置一部分，其原因可能是（　　）。",
            "question": "A. 虽然艺术品投资本身的投资风险较高，但是它与组合内的传统投资相关性较低，有可能提高组合收益，降低组合风险\nB. 艺术品投资因其稀缺性，所以总能取得正收益\nC. 多数艺术品知名度较高，所以投资的交易活跃度高，流动性好\nD. 多数艺术品投资信息透明度较高，容易估价，形成连续的市场价格",
            "answer": "A",
            "explain": "艺术品投资本身的投资风险较高，但是它与组合内的传统投资相关性较低，有可能提高组合收益，降低组合风险。艺术品虽然稀缺，但无法总能取得正收益。艺术品市场的交易活跃度较低，且在特征和质量方面难以描绘，因此对其投资价值评估较为困难。"
        },
        {
            "title": "关于证券市场线，以下表述正确的是（　　）。",
            "questions": "I. 证券市场线给出了所有有效投资组合风险与预期收益率之间的关系<br>II. 证券市场线给出了每一个风险资产的风险与预期收益率之间的关系<br>III. 证券市场线坐标图的横轴以标准差来衡量风险<br>IV. 证券市场线坐标图的横轴以贝塔值来衡量风险",
            "question": "A. II、IV\nB. I、III\nC. II、III\nD. I、IV",
            "answer": "A",
            "explain": "证券市场线描述了单个资产的风险溢价与市场风险之间的函数关系，即每一个风险资产风险与预期收益率之间的关系。"
        }, {
            "title": "某2年期的零息债券的市场价格为88元，面值为100元，则该债券的即期利率为（　　）。",
            "question": "A. 12.0%\nB. 6.6%\nC. 6.0%\nD. 6.8%",
            "answer": "B",
            "explain": "即期利率是指已设定到期日的零息债券的到期收益率。零息债券是一种以低于面值的贴现方式发行，不支付利息，到期按债券面值偿还的债券。其到期收益率的计算公式为P=M(1+y)^n，式中P表示债券的市场价格，M表示债券面值，n表示期数。将题中数代入公式可得，88=100(1+y)^2，y≈6.6%。"
        },
        {
            "title": "关于计算VaR值的蒙特卡洛模拟法，下列表述错误的是（　　）。",
            "question": "A. 蒙特卡洛模拟法的局限性是VaR计算所选用的历史样本期间非常重要\nB. 蒙特卡洛模拟法的计算量较大\nC. 蒙特卡洛模拟法被认为是最精准贴近的计算VaR值方法\nD. 蒙特卡洛模拟法在估值之前，需要有风险因子的概率分布模型，继而重复模拟",
            "answer": "A",
            "explain": "蒙特卡洛模拟法在估算之前，需要有风险因子的概率分布模型，继而重复模拟风险因子变动的过程。这种方法虽然计算量较大，但这种方法被认为是最精准贴近的计算VaR值方法。"
        },
        {
            "title": "基金公司投资交易流程包含的环节有（　　）。",
            "questions": "I. 形成投资策略<br>II. 构建投资组合和执行交易指令<br>III. 风险控制<br>IV. 绩效评估与组合调整",
            "question": "A. II、III\nB. I、II、III、IV\nC. I、II\nD. I、II、IV",
            "answer": "B",
            "explain": "基金公司投资交易流程包括形成投资策略、构建投资组合、执行交易指令、绩效评估与组合调整、风险控制等环节。"
        },
        {
            "title": "业内最常用的股票型基金相对收益归因分析模型是（　　）。",
            "question": "A. 特雷诺比率\nB. 平均收益率\nC. 夏普比率\nD. Brinson模型",
            "answer": "D",
            "explain": "对股票投资组合进行相对收益归因分析，最常用的是Brinson模型。股票投资经理在考虑如何战胜指数时，可以进行各种不同的资产配置或挑选不同的证券。相应地，Brinson模型中，资产配置效应是指把资金配置在特定的行业子行业或其他投资组合子集带来的超额收益，而选择效应则是挑选证券带来的超额收益。"
        },
        {
            "title": "下列债券属于无保证债券的是（　　）。",
            "question": "A. 质押债券\nB. 有限留置债券\nC. 担保债券\nD. 次级债券",
            "answer": "D",
            "explain": "无保证债券包括优先无保证债券、优先次级债券、次级债券、劣后次级债券。"
        },
        {
            "title": "某基金公司有4只基金A、B、C、D，基金A在2018年发生年度审计费用20000元，则A基金承担20000元审计费用。",
            "question": "A. 该基金公司承担20000元\nB. 4只基金各承担5000元\nC. A基金承担10000元，该基金公司承担10000元\nD. A基金承担20000元",
            "answer": "D",
            "explain": "基金运作费指为保证基金正常运作而发生的应由基金承担的费用包括审计费、律师费、上市年费、分红手续费持有人大会费、开户费、银行汇划手续费等。"
        }, {
            "title": "根据《证券法》，以下不属于证券登记结算机构职责的是（　　）。",
            "question": "A. 提供资金结算服务\nB. 提供集中登记服务\nC. 提供资金存管服务\nD. 提供投资咨询服务",
            "answer": "D",
            "explain": "证券登记结算机构是为证券交易提供集中登记、存管与结算服务，不以盈利为目的的法人。其为证券市场提供安全、高效的证券登记结算服务。"
        },
        {
            "title": "关于基金会计核算的特点，以下表述错误的是（　　）。",
            "question": "A. 基金会计核算以证券投资基金为会计核算主体\nB. 目前，我国基金会计核算已细化到日\nC. 基金会计核算的责任主体是基金管理人\nD. 基金取得的金融资产或负债按照持有到期类进行初始确认",
            "answer": "C",
            "explain": "基金会计的核算主体是证券投资基金。从及时性原则出发，基金会计期间划分更加细化，即以周甚至是日为核算披露期间。目前，我国的基金会计核算均已细化到日。会计核算的责任主体包括基金管理人和基金托管人，其中基金管理人是第一责任主体。基金取得的金融资产或负债按照持有到期类进行初始确认。"
        },
        {
            "title": "下列属于基金交易费用的是（　　）。",
            "question": "A. 分红手续费\nB. 过户费\nC. 上市年费\nD. 开户费",
            "answer": "B",
            "explain": "基金交易费的种类包括：(1)交易佣金；(2)印花税、过户费、经手费、证管费；(3)参与银行间债券市场交易的，还需向中央国债登记结算有限责任公司或银行间市场清算所股份有限公司支付银行间账户服务费，向同业拆借中心支付交易手续费等服务费用。"
        },
        {
            "title": "下列关于固定利率债券的表述中，错误的是（　　）。",
            "question": "A. 固定利率债券有固定到期日\nB. 固定利率债券有固定面值\nC. 固定利率债券有固定票面利率\nD. 固定利率债券在到期日一次性支付利息和本金",
            "answer": "D",
            "explain": "固定利率债券是由政府和企业发行的主要债券种类，有固定的到期日，并在债券期间内有固定的票面利率和不变的面值。通常，固定利率债券在偿还期内定期支付利息，并在到期日支付面值。"
        },
        {
            "title": "最大回撤，以下表述错误的是（　　）。",
            "question": "A. 最大回撤可以在任何历史区间做测度\nB. 制定的区间越短，最大回撤做指标就越不利\nC. 最大回撤测量投资组合在制定区间内从最高点到最低点的回撤\nD. 最大回撤衡量投资管理人对下行风险的控制能力",
            "answer": "B",
            "explain": "最大回撤测量投资组合在指定区间内从最高点到最低点的回撤，计算结果是在选定区间内任一历史时点往后推，产品净值走到最低点时的收益率回撤幅度的最大值。最大回撤可以在任何历史区间做测度，用于衡量投资管理人对下行风险的控制能力。指定区间越长，这个指标就越不利，因此在不同的基金之间使用该指标时，应尽量控制在同一个评估期间。"
        },
        {
            "title": "投资者需求由投资目标和投资限制构成，以下关于投资限制的表述错误的是（　　）。",
            "question": "A. 按照历史经验，投资期限较长的投资者获得良好的投资业绩\nB. 投资限制可能是投资者自己设定，也可能是由法律法规限定\nC. 通常来说，流动性与收益之间通常存在反向关系，对于同类产品，流动性更差的往往都有更高的预期收益率\nD. 税收政策不是影响投资决策的重要考量因素",
            "answer": "D",
            "explain": "税收政策是影响投资决策的重要考量因素。投资策略的业绩好坏是以税后收益率来衡量的。"
        }, {
            "title": "关于方差和标准差，以下说法错误的是（　　）。",
            "question": "A. 方差通常应用于分析投资收益率，但不可以用来研究价格指数、股指等波动情况\nB. 方差为a^2，标准差为a\nC. 对于r分布未知的情况，可以抽取样r1，r2...m，用其样本S^2来估计σ^2\nD. 对于投资收益率r,方差σ^2=E[(r-Er)^2]",
            "answer": "A",
            "explain": "方差和标准差除了应用于分析投资收益外，还可以用来研究价格指数、股指等波动情况。方差为a^2，标准差为a。对于r分布未知的情况，可以抽取样r1、r2...m，用其样本S^2来估计σ^2。对于投资收益率r，方差σ^2=E[(r-Er)^2]，它的数值越大，表示收益率r偏离期望收益率Er的程度越大，反之亦然。"
        },
        {
            "title": "关于风险和收益，以下说法错误的是（　　）。",
            "question": "A. 投资者的期望收益率取决于其所期待的风险溢价和无风险收益率的水平\nB. 由于无法有效分散，投资者对承担的系统性风险不要求风险溢价\nC. 在其他条件一致时，股票投资者对投资于风险更高的公司要求的期望收益率更高\nD. 投资者承担的风险越高，要求的风险溢价越多",
            "answer": "B",
            "explain": "权益类证券投资的风险主要包括系统性风险和非系统性风险；风险资产期望收益率等于无风险资产收益率与风险溢价之和。风险资产的期望收益率是由无风险收益率加上投资者投资风险资产所要求的溢价组成的，因此期望收益率取决于风险溢价和无风险收益率的水平。风险溢价是指风险厌恶的投资者购买风险资产而向他们提供的一种额外的期望收益率，因此投资者投资含有系统性风险的资产时也会要求相应的溢价。"
        },
        {
            "title": "以下不属于采用贴现发行方式的货币市场工具的是（　　）。",
            "question": "A. 短期政府债\nB. 大额可转让定期存单\nC. 同业存单\nD. 商业票据",
            "answer": "B",
            "explain": "短期政府债券是由一国的政府部门发行并承担到期偿付本息责任的，期限在1年及1年以内的债务凭证。短期政府债券以贴现形式发行，为无息票债券。大额可转让定期存单是银行发行的具有固定期限和一定利率的，且可以在二级市场上转让的金融工具。大额可转让定期存单采用批发式发行或零售式发行。同业存单是存款类金融机构在银行间市场上发行的记账式定期存款凭证，其投资和交易主体为全国银行间同业拆借市场成员。基金管理公司及基金类产品（包括信托公司）。同业存单是贴现债，即采用贴现形式发行。"
        },
        {
            "title": "以下不属于基金暂停估值情形的是（　　）。",
            "question": "A. 某只基金重合的债权到期后不能兑付，严重影响该基金的流动性\nB. 港股通产品，因台风警报，联交所宣布闭市一天\nC. 某基金银投资经理申请年休假，基金无人管理\nD. 因估值系统准备不充分，某基金无法正确算出产品应纳增税额",
            "answer": "C",
            "explain": "当基金有以下情形时，可以暂停估值：(1)基金投资所涉及的证券交易所遇法定节假日或因其他原因暂停营业时；(2)因不可抗力或其他情形致使基金管理人、基金托管人无法准确评估基金资产价值时；(3)占基金相当比例的投资品种的估值出现重大转变，而基金管理人为保障投资人的利益已决定延迟估值；(4)如出现基金管理人认为属于紧急事故的任何情况，会导致基金管理人不能出售或评估基金资产的；(5)中国证监会和基金合同认定的其他情形。"
        },
        {
            "title": "关于基金费用，以下表述错误的是（　　）。",
            "question": "A. 目前我国的基金销售服务费是按前一日基金资产净值的一定比例逐日计提，按月支付\nB. 基金销售服务费是向基金管理人收取的，用于支付销售机构佣金的费用\nC. 基金托管费是基金托管人提供托管服务而向基金收取的费用\nD. 基金管理费是基金管理人管理基金资产而向基金收取的费用",
            "answer": "B",
            "explain": "销售服务费指从基金资产中扣除的用于支付销售机构佣金以及基金管理人的基金营销广告费、保销活动费、持有人服务费等方面的费用。"
        },
        {
            "title": "在单笔交易规模较大的债券市场中，比较适合的结算方式是（　　）。",
            "question": "A. 双边净额结算\nB. 逐笔结算\nC. 券款净额结算\nD. 多边净额结算",
            "answer": "B",
            "explain": "全额结算即逐笔结算，适用于高度自动化系统的单笔交易规模较大的市场。"
        }, {
            "title": "交易指令在基金公司内部执行的流程为（　　）。",
            "questions": "I. 交易员择机执行指令<br>II. 相关人员审核指令<br>III. 基金经理下达指令",
            "question": "A. II、III、I\nB. III、II、I\nC. I、II、III\nD. I、III、II",
            "answer": "B",
            "explain": "交易指令在基金公司内部的执行情况如下：(1)在自主权限内，基金经理通过交易系统向交易室下达交易指令；(2)交易系统或相关负责人员审核投资指令的合法合规性，违规指令将被拦截，反馈给基金经理，其他指令被分发给交易员。"
        },
        {
            "title": "某企业的资产收益率是20%，若资产负债率也为20%，则净资产收益率是（　　）。",
            "question": "A. 20%\nB. 15%\nC. 25%\nD. 30%",
            "answer": "C",
            "explain": "资产收益率是20%，若资产负债率也为20%则权益率=1+(1-20%)=1.25;净资产收益率=20%×1.25=25%。"
        },
        {
            "title": "根据中央国债登记结算公司有关结算账户管理规定，QFII、RQFII可以在银行间债券市场参与交易，但只能申请成为丙类结算成员，在债券结算时需委托甲类结算成员办理。此处体现的交易制度是（　　）。",
            "question": "A. 结算参与人制度\nB. 做市商制度\nC. 公开市场一级交易商制度\nD. 结算代理制度",
            "answer": "D",
            "explain": "结算代理制度指经由中国人民银行批准可以开展结算代理业务的金融机构法人，受市场其他参与者的委托，为其办理债券结算业务的制度。"
        },
        {
            "title": "关于混合基金的风险管理，以下表述正确的是（　　）。",
            "question": "A. 混合基金的风险低于股票基金，预期收益低于债券基金\nB. 混合基金股票仓位较高时，可对基金行业集中度、持股集中度等风险指标进行监控\nC. 一般而言，混合基金中偏股型基金的风险和预期收益较高，平衡型基金相对较低，偏债型基金介于两者之间\nD. 债券基金与混合型基金相比，其风险管理更加多样化",
            "answer": "B",
            "explain": "混合基金股票仓位较高时，可参照股票型基金，对基金行业集中度、持股集中度等风险指标进行监控。"
        },
        {
            "title": "以下选项中，关于净资产收益中的表述正确的是（　　）。",
            "question": "A. 净资产收益率总是小于资产收益率\nB. 净资产收益率能准确衡量公司对股东的财富回报能力\nC. 净资产收益率能充分反应企业利用总资产创造利润的能力\nD. 净资产收益率能反应企业中短期的回款能力",
            "answer": "B",
            "explain": "由于现代企业最重要的经营目标就是最大化股东财富，因而净资产收益率是衡量企业最大化股东财富能力的比率。"
        },
        {
            "title": "关于系统性风险和非系统性风险，以下表述错误的是（　　）。",
            "question": "A. 政策风险属于系统性风险\nB. 非系统性风险往往是由某个或少数特别因素导致的风险\nC. 非系统性风险主要包括由政治因素、宏观经济因素、法律因素等引起的风险\nD. 组合化投资可以分散非系统性风险",
            "answer": "C",
            "explain": "非系统性风险主要包括由政治因素、宏观经济因素、法律因素等引起的风险，C选项说法错误。"
        }, {
            "title": "关于基金利润分配，以下说法中正确的是（　　）。",
            "question": "A. 对基金份额净值和投资者利益没有实际影响\nB. 会导致基金份额净值和投资者利益的下降\nC. 对基金份额净值没有实际影响，但会导致投资者利益下降\nD. 会导致基金份额净值的下降，但对投资者利益没有实际影响",
            "answer": "D",
            "explain": "基金进行利润分配会导致基金份额净值的下降，但对投资者利益没有实际影响。"
        },
        {
            "title": "投资者在考察其所投资的私募股权基金时会画出一条曲线，被称为J曲线，以下相关表述正确的是（　　）。",
            "question": "A. 对投资者而言，私募股权基金在投资前期，主要是以投入资金为主\nB. J曲线意味着私募股权投资通常可在一两年内获得回报\nC. J曲线以风险为横轴，以收益为纵轴\nD. 对投资者而言，私募股权基金通常在项目后期，开始现金流出",
            "answer": "A",
            "explain": "对于投资者而言，私募股权基金在其投资项目的前段时期，主要是以投入资金为主，经过一段时间的运营后，对项目所投入的资金逐步降低乃至停止，现金流入增加。"
        },
        {
            "title": "对某上市公司股票价格的估值，如估值日该股票停牌，最近交易日证券市场未发生重大跌涨，且该上市公司也未发生重大事件，则基金管理人应（　　）。",
            "question": "A. 采用普遍认同的估值技术确定该股票的公允价值\nB. 采用该股票的最近交易市值估值\nC. 按该股票的减本价估值\nD. 参考同行业其他上市公司股票的现行市价估值",
            "answer": "B",
            "explain": "对于上市公司股票价格的估值，如估值日该股票停牌，最近交易日证券市场未发生重大跌涨，且该上市公司也未发生重大事件，则基金管理人应采用该股票的最近交易市值估值。"
        },
        {
            "title": "我国的基金会计核算细化到了（　　）。",
            "question": "A. 日\nB. 季度\nC. 年\nD. 月",
            "answer": "A",
            "explain": "从及时性原则出发，基金会计期间划分更加细化，即以周甚至是日为核算披露期间。目前，我国的基金会计核算均已细化到日。"
        },
        {
            "title": "某QDII基金委托境外投资顾问进行境外证券投资，该投资顾问同时还受托管理其他境外对冲基金，投资顾问在其投资及运营过程中发生的下列行为符合相关规定的是（　　）。",
            "question": "A. 在尽职调查过程中，披露委托人QDII基金的详细信息\nB. 经过内部决策流程，提交了买入股票A的投资建议\nC. 经过内部讨论，同意不披露重大利益冲突事项\nD. 在同时处理对冲基金和QDII基金的投资建议时，优先处理QDII基金的投资建议",
            "answer": "B",
            "explain": "经过内部决策流程，提交买入A股票的投资建议符合相关规定。"
        },
        {
            "title": "某上市公司近年来积极通过各种融资手段筹资并大举扩张，经统计有公司债、优先股、定向增发股票筹集等。由于经营不善，公司拟进入解散或破产清算程序，以下哪类权益持有人可以获得最优先的清偿顺序（　　）。",
            "question": "A. 参与了定向增发的股东\nB. 公司债的持有人\nC. 普通股股东\nD. 优先股股东",
            "answer": "B",
            "explain": "债权资本是一种借入资本，代表了公司的合约义务，因此债券持有者/债权人拥有公司资产的最高索取权。"
        }, {
            "title": "1亿元的组合有1亿元的管法，10亿元的组合有10亿元的管法，100亿元的组合更有100亿元的管法，这句话体现了基金业绩评价需要考虑以下哪个方面（　　）。",
            "question": "A. 申购金额\nB. 初始募资金额\nC. 赎回金额\nD. 基金管理规模",
            "answer": "D",
            "explain": "基金管理规模的大小影响基金管理人的投资行为，进而影响基金业绩，因而基金业绩评价需考虑基金管理规模。"
        },
        {
            "title": "投资衍生工具对所面临的风险主要包括（　　）。",
            "questions": "I. 价格风险<br>II. 违约风险<br>III. 运作风险<br>IV. 法律风险",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III\nD. I、II、III、IV",
            "answer": "D",
            "explain": "衍生工具面临的风险主要包括：(1)交易双方中的某方违约的违约风险；(2)价格风险；(3)运作风险；(4)法律风险。"
        },
        {
            "title": "下列关于债券投资的风险的表述，正确的是（　　）。",
            "question": "A. 债券的价格与利率呈反向变动关系\nB. 浮动利率债务相比固定利率债券在利率下行环境中具有较低的利率风险\nC. 固定利率债券和零息债券的价格与市场利率无关\nD. 浮动利率债券相比固定利率债券在利率上升环境中具有较高的利率风险",
            "answer": "A",
            "explain": "债券的价格与利率呈反向变动关系。浮动利率债券相比固定利率债券在利率下行环境中具有较高的利率风险，在利率上升环境中具有较低的利率风险。"
        },
        {
            "title": "证券回转交易是指（　　）。",
            "question": "A. 投资者买入的证券，经确认成交后，在交收完成前全部或部分卖出\nB. 投资者买入的证券，经确认成交后，在交收完成前，可以全部卖出，但不可部分卖出\nC. 投资者买入的证券，经确认成交后，在交收完成前，可以撤销该笔全部或部分数量的交易\nD. 投资者买入的证券，经确认成交后，在交收完成前，可以撤销全部数量的交易，但不可撤销部分数量的交易",
            "answer": "A",
            "explain": "回转交易是指投资者买入的证券，经确认成交后，在交收完成前全部或部分卖出。"
        },
        {
            "title": "某基金分红前的总净值为7500万元，份额数5000万份。该基金计划每10份份额派0.15元红利，形式为红利再投资，则本次分红后，基金的总净值和份额净值分别为（　　）。",
            "question": "A. 7500万元，1.4850元\nB. 7425万元，1.4850元\nC. 7500万元，1.5000元\nD. 7425万元，1.5000元",
            "answer": "A",
            "explain": "基金份额净值=基金资产净值/基金份额。分红后的基金份额净值=1.5-0.15/10=1.4850元。分红再投资转换为基金份额是指将应分配的净利润按除息后的份额净值折算为新的基金份额进行基金收益分配。"
        },
        {
            "title": "关于债券基金针对交易对手的信用风险的监控指标和管理方式，以下表述错误的是（　　）。",
            "question": "A. 定期评估交易对手的信用资质和交易对手限额管理\nB. 根据组合的实际情况合理配置资产的投资期限和比例\nC. 控制可流通股票资产变现天数\nD. 控制交易对手集中度和组合集中度",
            "answer": "C",
            "explain": "控制可流通股票资产变现天数属于流动性风险管理。"
        },
        {
            "title": "期货市场的基本功能包括（　　）。",
            "questions": "I. 风险管理<br>II. 价格发现<br>III. 投机",
            "question": "A. II、III\nB. I、II、III\nC. I、II\nD. I、III",
            "answer": "B",
            "explain": "期货市场的基本功能包括风险管理、价格发现和投机。"
        },
        {
            "title": "甲公司2015年资产收益率为10%，净资产收益率为25%，则甲公司2015年的资产负债率为（　　）。",
            "question": "A. 60%\nB. 2.5%\nC. 50%\nD. 40%",
            "answer": "A",
            "explain": "本题考查资产负债率的计算。净资产收益率=资产收益率×权益乘数；权益乘数=1/(1-资产负债率)。"
        },
        {
            "title": "关于并购投资的投资形式，不正确的是（　　）。",
            "question": "A. 管理层收购使其从企业的经营者变成企业的所有者\nB. 杠杆收购对企业现金流的要求不高\nC. 并购投资的主要对象是成熟且具有稳定现金流，呈现出稳定增长的企业\nD. 杠杆投资是并购中应用最广泛的形式",
            "answer": "B",
            "explain": "杠杆收购对企业现金流的要求较高，因为需要通过借贷来支付大部分交易费用，并且这些费用需要通过被收购公司的未来现金流来支付。"
        },
        {
            "title": "基金财务会计报告中，基金持仓结构分析股票投资占比的计算方式正确的是（　　）。",
            "question": "A. 股票投资总成本+基金的投资总额\nB. 股票投资总成本+基金资产净值\nC. 股票投资总市值+基金的投资总额\nD. 股票投资总市值+基金资产净值",
            "answer": "D",
            "explain": "基金持仓结构分析股票投资占比=股票投资总市值+基金资产净值。"
        },
        {
            "title": "某股票的前收盘价为10元，配股价格为6元，股份变动比例为100%，那么除权参考价为（　　）。",
            "question": "A. 9元\nB. 8元\nC. 10元\nD. 2元",
            "answer": "A",
            "explain": "除权(息)参考价=(前收盘价-现金红利+配股价格×股份变动比例)÷(1+股份变动比例)。"
        },
        {
            "title": "关于保证金交易业务，以下表述正确的是（　　）。",
            "question": "A. 融券业务会放大投资收益和损失，融资业务不会\nB. 融券没有资金成本\nC. 卖空交易表明投资者认为股票价格会下跌\nD. 保证金交易能够减少资金占用，降低投资杠杆和风险",
            "answer": "C",
            "explain": "卖空交易表明投资者预期股票价格会下跌，通过借入证券卖出以期获得收益。"
        }, {
            "title": "关于期货合约和远期合约的区别，以下表述正确的是（　　）。",
            "questions": "I. 相对远期合约而言，期货合约是标准化合约<br>II. 期货合约在交易所交易，远期合约不在交易所交易<br>III. 期货合约是远期合约的升级<br>IV. 远期合约一般不能用替代品进行交割，期货合约的交货人可以交易所认可的替代品进行实物交割",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. II、III\nD. I、II、III",
            "answer": "A",
            "explain": "期货合约是标准化合约，远期合约一般不在交易所进行交易，而是在金融机构之间或金融机构与客户之间通过谈判后签署的，因此是非标准化合约；期货合约在交易所交易，是标准化合约；期货合约是远期合约的升级；远期合约一般不能用替代品进行交割，期货合约的交货人可以交易所认可的替代品进行实物交割。"
        },
        {
            "title": "关于沪深300指数，以下描述错误的是（　　）。",
            "question": "A. 沪深300指数是加权平均指数\nB. 沪深300指数覆盖沪市和深市\nC. 沪深300指数以2004年12月31日为基期，基点为1000点\nD. 沪深300价格指数和沪深300全收益指数都实时发布",
            "answer": "D",
            "explain": "中证指数有限公司同时计算并发布沪深300价格指数和全收益指数，其中，价格指数实时发布，全收益指数每日收盘后在中证指数公司网站上公布。"
        },
        {
            "title": "在某一时点看涨期权标的资产的市场价格大于其执行价格，则该期权是一份（　　）。",
            "question": "A. 实值期权\nB. 零值期权\nC. 平价期权\nD. 虚值期权",
            "answer": "A",
            "explain": "实值期权是指如果期权立即被执行，买方具有正的现金流。"
        },
        {
            "title": "如果dt表示t时期的贴现因子，st表示t时期的即期利率，则贴现因子与即期利率的关系可以表示为（　　）。",
            "question": "A. dt=(1+st)^t\nB. dt=1/(1+st)^t\nC. dt=1+st\nD. dt=1/(1+st)",
            "answer": "B",
            "explain": "未来现金流通过贴现因子成倍折现得到相应的现值，计算公式为dt=1/(1+st)^t，式中，dt表示贴现因子，st表示即期利率，t表示期数。"
        },
        {
            "title": "目前，我国银行间市场债券结算业务类型不包括（　　）。",
            "question": "A. 现券业务\nB. 买断式回购业务\nC. 货币互换\nD. 债券借贷",
            "answer": "C",
            "explain": "目前，我国银行间市场债券结算业务包括：分销业务、现券业务、质押式回购业务、买断式回购业务、债券远期交易、债券借贷业务。"
        },
        {
            "title": "关于利率期限结构，以下表述正确的是（　　）。",
            "question": "A. 反转收益曲线的特征是，短期债券收益率较低\nB. 到期期限足以解释不同债券收益率的差异\nC. 收益率曲线只有4种类型\nD. 拱型收益率曲线的特征是，期限相对较短的债券利率与期限成正向关系",
            "answer": "D",
            "explain": "拱型收益率曲线的特征是，期限相对较短的债券利率与期限成正向关系。"
        }, {
            "title": "名义利率是指包含对（　　）补偿的利率。",
            "question": "A. 即期收益率\nB. 到期收益率\nC. 无风险利率\nD. 通货膨胀",
            "answer": "D",
            "explain": "名义利率包含对通货膨胀补偿的利率，当物价不断上涨时，名义利率比实际利率高。通常所说的年利率都是指名义利率。"
        },
        {
            "title": "某基金基金合同描述如下：本基金将充分发挥自上而下的主动选股能力，同时由主动进行辅助性大类资产配置，在投资组合中加入债券等固定收益类资产以优化整个资产组合的风险收益配比和流动性，上述描述的是由（　　）确定的。",
            "question": "A. 研究部\nB. 投资部\nC. 风险管理部\nD. 投资决策委员会",
            "answer": "B",
            "explain": "投资部负责根据投资决策委员会制定的投资原则和计划制定投资组合的具体方案，向交易部下达投资指令，在执行阶段，投资经理会结合投资组合的既定目标、资本市场预期和分析师报告等来制定组合构建和证券选择等方面的决策。"
        },
        {
            "title": "关于债券投资组合的构建，以下表述错误的是（　　）。",
            "question": "A. 不同于股票构建组合，债券投资组合构建还需要考虑信用结构、期限结构、组合久期、流动性和杠杆性等因素\nB. 一般来说，债券的当期收益与股票一样难以预测\nC. 债券型基金需要在招募说明书中说明基金的投资目标、投资理念、投资范围、业绩基准等内容，这奠定了基金投资组合的构建理念和流程\nD. 债券有其不同于股票的独特分析方法，主要分析指标有到期收益率、利率期限结构、久期、凸性等",
            "answer": "B",
            "explain": "债券通常又称固定收益证券，因为其能够提供固定数额或根据固定公式计算出的现金流，因此其当期收益在很大程度上是可预测的。"
        },
        {
            "title": "与平均收益率低的基金相比，平均收益率高的基金的基金经理的投资能力（　　）。",
            "question": "A. 一样\nB. 高\nC. 低\nD. 信息不足，无法比较",
            "answer": "D",
            "explain": "基金经理的投资能力不仅体现在管理基金的平均收益率上，更重要的是比较风险调整后收益，如夏普比率、特雷诺比率和詹森比率等指标，因此单凭平均收益率无法比较。"
        },
        {
            "title": "关于利率互换和货币互换以下表述正确的是（　　）。",
            "question": "A. 货币互换的合约的一方具有货币交换的权利，而没有货币交换的义务\nB. 货币互换的合约双方互换的是不同币种为单位的利率\nC. 利率互换的合约双方交换的是双方认为具有相等经济价值的现金流\nD. 利率互换的合约双方互换的是不同币种下的相同利率",
            "answer": "C",
            "explain": "货币互换是指互换合约双方在约定期限内按相同或不同的利息计算方式向对方支付由不同币种的等值本金额确定的利息。利率互换属于互换合约，因此利率互换的合约双方交换的是双方认为具有相等经济价值的现金流。"
        },
        {
            "title": "关于现值和贴现，以下表述错误的是（　　）。",
            "question": "A. 现值计算中利率也被称为贴现率\nB. 未来某时点资金的价值折算为现在时点的价值称为贴现\nC. 现值是指将来货币金额的未来价值\nD. 现值的复利计算公式一般为PV=FV*(1+i)^n",
            "answer": "C",
            "explain": "将未来某时点资金的价值折算为现在时点的价值称为贴现，因此利率也被称为贴现率。现值即现在值，是指将来货币金额的现在价值，C选项表述错误。"
        }, {
            "title": "关于基本面分析，以下表述错误的是（　　）。",
            "question": "A. 基本面分析通常研究成交量、涨跌幅和图形走势等来推测股价的变动趋势\nB. 公司未来的经营业绩和盈利水平是基本面分析的核心\nC. 分析预期收益等价值决定因素的分析方法称为基本面分析\nD. 基本面分析包括宏观经济分析、行业分析和公司分析",
            "answer": "A",
            "explain": "基本面分析通常研究成交量、涨跌幅和图形走势等来推测股价的变动趋势，是通过研究金融市场的历史信息来预测股票价格的趋势，是技术分析的表述，不是基本面分析的表述。"
        },
        {
            "title": "某基金A在持有期为12个月，置信水平为95%的情况下，若计算的风险价值为5%，则以下表述正确的是（　　）。",
            "question": "A. 该基金在12个月中的损失有95%的可能不超过5%\nB. 该基金在12个月中的损失有5%的可能不超过5%\nC. 该基金在12个月中的损失有5%的可能不超过95%\nD. 该基金在12个月中的最大损失为5%",
            "answer": "A",
            "explain": "预期损失是指在给定时间区间和置信区间内，投资组合损失的期望值。在置信水平X下，意味着有X%的把握保证T内投资的损失不会大于V。"
        },
        {
            "title": "某投资组合的平均收益率为20%，假设无风险收益率为3%(年化)，该基金的年化收益率为20%，贝塔系数为0.85，则特雷诺比率为（　　）。",
            "question": "A. 0.2\nB. 0.68\nC. 0.8\nD. 0.25",
            "answer": "A",
            "explain": "特雷诺比率表示的是单位系统风险下的超额收益率，用公式表示为：T=R-Rf/β，其中，T为特雷诺比率，R为投资组合的收益率，Rf为无风险收益率，β为贝塔系数。"
        },
        {
            "title": "基金资产其他收入包含（　　）。",
            "question": "A. 存出保证金的利息收入\nB. 衍生工具收入\nC. ETF替代收入\nD. 股利收入",
            "answer": "C",
            "explain": "其他收入包括赎回费扣除基本手续费后的余额、手续费返还、ETF替代损益，以及基金管理人等机构为弥补基金财产损失而付给基金的赔偿款项等。"
        },
        {
            "title": "以下选项不属于不动产投资工具的是（　　）。",
            "question": "A. 房地产有限合伙\nB. 房地产物业管理\nC. 房地产权益基金\nD. 房地产投资信托",
            "answer": "B",
            "explain": "不动产投资工具包括房地产有限合伙、房地产权益基金和房地产投资信托等。"
        },
        {
            "title": "关于全球投资业绩标准（GIPS），以下表述正确的是（　　）。",
            "question": "A. 投资管理机构必须披露3年以上的业绩\nB. 它属于强制执行的业绩标准\nC. 投资管理机构使用GIPS标准进行披露时，必须同时遵守它提供的两套标准\nD. GIPS业绩评价的基础是输入数据的真实、准确",
            "answer": "D",
            "explain": "GIPS标准包含两套，一套为必须遵守的规定，投资管理机构必须在全体一致遵守所有规定的情况下，方可宣称已符合标准；另一套为推荐遵守的行业最高标准。"
        },
        {
            "title": "如果证券市场为半强有效市场，则证券价格能够充分反映以下信息中的（　　）。",
            "questions": "I. 内部信息<br>II. 历史股价<br>III. 历史成交量<br>IV. 公司分红公告\nV. 股票分拆公告",
            "question": "A. I、IV、V\nB. II、III、IV、V\nC. II、III\nD. I、III、V",
            "answer": "B",
            "explain": "半强有效市场的概念是指证券价格能够充分反映所有公开信息和部分内部信息。"
        },
        {
            "title": "净额结算方式与全额结算方式的主要差异在于（　　）。",
            "question": "A. 是否采用货银对付原则\nB. 对交易进行差额清算还是逐笔清算\nC. 结算场所是否在中国结算公司上海分公司\nD. 是否实时进行结算",
            "answer": "B",
            "explain": "净额结算又称差额清算，指在一个清算期中，对每个结算参与人价款的清算只计其各笔应收，应付款项相抵后的净额，对证券的清算只计每一种证券应收、应付和抵后的净额。"
        },
        {
            "title": "某公司用部分现金购买了存货，那么该公司流动比率和速动比率的变化将是（　　）。",
            "question": "A. 流动比率不变，速动比率变小\nB. 流动比率不变,速动比率不变\nC. 流动比率变小，速动比率不变\nD. 流动比率变小，速动比率变小",
            "answer": "A",
            "explain": "流动比率=流动资产/流动负债，速动比率=(流动资产-存货)/流动负债；使用现金购买存货，是流动资产的内部转换，不影响流动比率；流动资产不变，存货增加，流动资产减去存货数值降低，则速动比率降低。"
        },
        {
            "title": "以下证券价格指数中，出现最早的是（　　）。",
            "question": "A. 标准普尔500指数\nB. 沪深300指数\nC. 道琼斯股票价格平均指数\nD. 中证全债指数",
            "answer": "C",
            "explain": "道琼斯股票价格平均指数最早是在1884年由道琼斯公司的创始人查尔斯·亨利·道开始编制的。"
        },
        {
            "title": "关于私募股权投资的退出方式，表述错误的是（　　）。",
            "question": "A. 首次公开发行并上市（IPO）的退出模式，是指所投资的企业股权在交易所公开上市交易后在交易所出售\nB. 借壳上市的退出模式是一种间接上市的方法\nC. 二次出售是指私募股权投资基金将所持有的项目在私募股权二级市场出售的行为\nD. 管理层回购模式是指私募股权投资基金将所持有的股权转换为管理层所控股的其他上市公司的股权",
            "answer": "D",
            "explain": "管理层回购模式是指私募股权投资基金将所持有的股权转换为管理层所控股的其他上市公司的股权，D选项说法错误。"
        },
        {
            "title": "杜邦恒等式中，不涉及的财务指标是（　　）。",
            "question": "A. 资产负债率\nB. 销售利润率\nC. 权益乘数\nD. 总资产周转率",
            "answer": "A",
            "explain": "杜邦恒等式为净资产收益率=销售利润率×总资产周转率×权益乘数，该等式中，销售利润率、权益乘数、总资产周转率均涉及，A选项资产负债率未涉及。"
        }, {
            "title": "以下关于中证全债指数的说法，错误的是（　　）。",
            "question": "A. 样本包括银行间市场和沪深交易所市场的国债、金融债券和企业债券\nB. 中证指数公司每日计算并发布收盘指数\nC. 当成分券出现异常价格或无价格的情况下，计算指数时剔除该成分券\nD. 是中证指数公司编制并发布的第一只债券类指数",
            "answer": "C",
            "explain": "中证全债指数的一个重要特点在于对异常价格和无价情况下适用了模型价，能更为真实地反映债券的实际价值和收益率特征。"
        },
        {
            "title": "中央银行通过货币政策对宏观经济进行调控，其不会采用的政策工具是（　　）。",
            "question": "A. 财政支出的调节\nB. 公开市场操作\nC. 利率水平调节\nD. 存款准备金率的调节",
            "answer": "A",
            "explain": "中央银行货币政策采用的三项政策工具有：(1)公开市场操作，主要内容是央行在货币市场上买卖短期国债；(2)利率水平的调节；(3)存款准备金率的调节。"
        },
        {
            "title": "根据《中国证券监督管理委员会关于证券投资基金估值业务的指导意见》，为提高基金估值的合理性和可靠性，可对没有活跃市场或在活跃市场不存在相同特征的资产或负债股价的投资品种制定估值指引的是（　　）。",
            "question": "A. 基金管理人\nB. 中国证券投资基金业协会\nC. 中国证监会\nD. 基金托管人",
            "answer": "B",
            "explain": "为提高估值的合理性和可靠性，中国证券投资基金业协会建立了基金估值工作机制，在充分征求行业意见并向中国证监会报备后，对没有活跃市场或在活跃市场不存在相同特征的资产或负债的投资品种提出估值指引，并定期对其出台的估值指引进行评估和修订。"
        },
        {
            "title": "以下关于中证全债指数的说法，错误的是（　　）。",
            "question": "A. 样本包括银行间市场和沪深交易所市场的国债、金融债券和企业债券\nB. 中证指数公司每日计算并发布收盘指数\nC. 当成分券出现异常价格或无价格的情况下，计算指数时剔除该成分券\nD. 是中证指数公司编制并发布的第一只债券类指数",
            "answer": "C",
            "explain": "中证全债指数的一个重要特点在于对异常价格和无价情况下适用了模型价，能更为真实地反映债券的实际价值和收益率特征。"
        },
        {
            "title": "中央银行通过货币政策对宏观经济进行调控，其不会采用的政策工具是（　　）。",
            "question": "A. 财政支出的调节\nB. 公开市场操作\nC. 利率水平调节\nD. 存款准备金率的调节",
            "answer": "A",
            "explain": "中央银行货币政策采用的三项政策工具有：(1)公开市场操作，主要内容是央行在货币市场上买卖短期国债；(2)利率水平的调节；(3)存款准备金率的调节。"
        },
        {
            "title": "根据《中国证券监督管理委员会关于证券投资基金估值业务的指导意见》，为提高基金估值的合理性和可靠性，可对没有活跃市场或在活跃市场不存在相同特征的资产或负债股价的投资品种制定估值指引的是（　　）。",
            "question": "A. 基金管理人\nB. 中国证券投资基金业协会\nC. 中国证监会\nD. 基金托管人",
            "answer": "B",
            "explain": "为提高估值的合理性和可靠性，中国证券投资基金业协会建立了基金估值工作机制，在充分征求行业意见并向中国证监会报备后，对没有活跃市场或在活跃市场不存在相同特征的资产或负债的投资品种提出估值指引，并定期对其出台的估值指引进行评估和修订。"
        },
        {
            "title": "关于银行间债券远期交易，以下说法错误的是（　　）。",
            "question": "A. 从成交日至结算日最长不得超过180天\nB. 实行净价交易，全价结算\nC. 价格和数量在成交时约定\nD. 到期应该实际交割资金和债券",
            "answer": "A",
            "explain": "银行间债券市场中，债券远期交易从成交日至结算日的期限最长不得超过365天。"
        },
        {
            "title": "关于股份公司的债券，下列说法错误的是（　　）。",
            "question": "A. 公司债券需要还本付息，不属于公司资本\nB. 公司债券利率一般高于同期国债利率\nC. 优先股和普通股都代表对公司的所有权\nD. 普通股股东可以获得公司的分红",
            "answer": "A",
            "explain": "公司债券是公司依照法定程序发行的，约定在一定期限内还本付息的有价证券，是属于公司债权资本的。"
        },
        {
            "title": "关于我国的证券交易所，以下描述正确的是（　　）。",
            "question": "A. 我国证券交易所的决策机构是董事会\nB. 我国的证券交易所的设立是由证监会决定\nC. 我国证券交易所的总经理是由国务院证券监督管理机构任免\nD. 我国的证券交易所都采用的是公司制",
            "answer": "C",
            "explain": "我国证券交易所的总经理是由国务院证券监督管理机构任免。"
        }, {
            "title": "小芳购买了某公司发行的面值为100元的3年期债券共100张，利率为5%，每年付息一次，该笔投资共获得利息收入（　　）元。",
            "question": "A. 10500\nB. 1500\nC. 10100\nD. 11500",
            "answer": "B",
            "explain": "本题考查利息的计算。本题中，小芳购买了某公司发行的面值为100元的3年期债券共100张，利率为5%，每年付息一次，则利息收入为：100x100x5%x3=1500元。"
        },
        {
            "title": "关于基金的绝对收益和相对收益，以下描述错误的是（　　）。",
            "question": "A. 基金的绝对收益是指基金在一定时间区间内所获得的回报\nB. 基金的绝对收益没有考虑承担风险的大小\nC. 基金的相对收益是指基金相对于同类基金的收益\nD. 公募基金注重于相对收益考核",
            "answer": "C",
            "explain": "基金的相对收益，又叫超额收益代表一定时间区间内，基金收益超出业绩比较基准的部分。"
        },
        {
            "title": "2015年12月18日，香港证监会注册了首批内地互认基金，不包括（　　）。",
            "question": "A. 摩根亚洲总收益债券基金\nB. 工银瑞信核心价值混合型证券投资基金\nC. 华夏回报混合证券投资基金\nD. 汇丰晋信大盘股票型证券投资基金",
            "answer": "A",
            "explain": "香港证监会注册了首批内地互认基金，共4只，分别是华夏回报混合证券投资基金、工银瑞信核心价值混合型证券投资基金、广发行业领先混合型证券投资基金和汇丰晋信大盘股票型证券投资基金。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/jjjc-5.js